module.exports = "https://web-assets.ifttt.com/packs/media/docs/countless_possibilities-33b62556.png";